import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-[70px] px-4 sm:px-6 flex justify-end items-center" }
const _hoisted_2 = { class: "py-2" }

import { useRoute } from "vue-router";
import { twMerge } from "tailwind-merge";
import Divider from "./Divider.vue";
import Lucide from "../../base-components/Lucide";
import {
  FormattedMenu,
  nestedMenu,
} from "@/components/MainMenu/main-menu";
import { watch, reactive, computed, onMounted, ref } from "vue";
import SimpleBar from "simplebar";
import { useStore } from "vuex";
import { setRoutes } from "@/services/router/router.service";
import MobileMenuComponent from "./MobileMenuComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileMenu',
  setup(__props) {

const store = useStore();

const setMenuFixed = ref(false);

const route = useRoute();
const menuLayout = "side-menu";
const formattedMenu = ref([]);
const setFormattedMenu = (
  computedFormattedMenu: Array<FormattedMenu | "divider">
) => {
  formattedMenu.value = computedFormattedMenu;
};
const sideMenu = computed(() => nestedMenu(store.state.menu, route));

const activeMobileMenu = ref(false);

const setActiveMobileMenu = (active: boolean) => {
  if (active) {
    // @ts-ignore
    document.getElementById("sub-main").classList.add("hidden");
    // @ts-ignore
    document.getElementById("sub-platform").classList.add("hidden");
  } else {
    // @ts-ignore
    document.getElementById("sub-main").classList.remove("hidden");
    // @ts-ignore
    document.getElementById("sub-platform").classList.remove("hidden");
  }
  activeMobileMenu.value = active;
};

// @ts-ignore
const scrollableRef = ref<HTMLDivElement>();

watch(
  computed(() => route.path),
  () => {
    // @ts-ignore
    setFormattedMenu(nestedMenu(store.state.menu, route));
  }
);

watch(
  () => store.state.menu,
  function () {
    const url = window.location.href;
    var path = url.split("/")[3];
    if (path.includes("?")) {
      path = path.split("?")[0];
    }
    setFormattedMenu(sideMenu.value);
  }
);

function scrollTrigger() {
  if (window.pageYOffset > 112) {
    setMenuFixed.value = true;
  } else {
    setMenuFixed.value = false;
  }
}

onMounted(() => {
  window.addEventListener("scroll", scrollTrigger);
  if (scrollableRef.value) {
    new SimpleBar(scrollableRef.value);
  }

  setFormattedMenu(sideMenu.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      {
        'fixed top-0': setMenuFixed.value,
        'absolute ': !setMenuFixed.value,
      },
      'w-full bg-primary/90 z-[51] border-b border-white/[0.08] mb-6 dark:bg-darkmode-800/90 md:hidden',
      'before:content-[\'\'] before:w-full before:h-screen before:z-10 before:fixed before:inset-x-0 before:bg-black/90 before:transition-opacity before:duration-200 before:ease-in-out',
      !activeMobileMenu.value && 'before:invisible before:opacity-0',
      activeMobileMenu.value && 'before:visible before:opacity-100',
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        onClick: _cache[1] || (_cache[1] = (e) => e.preventDefault())
      }, [
        _createVNode(_unref(Lucide), {
          icon: "BarChart2",
          class: "w-8 h-8 text-white transform -rotate-90",
          onClick: _cache[0] || (_cache[0] = 
            () => {
              setActiveMobileMenu(!activeMobileMenu.value);
            }
          )
        })
      ])
    ]),
    _createElementVNode("div", {
      ref_key: "scrollableRef",
      ref: scrollableRef,
      class: _normalizeClass(
        _unref(twMerge)([
          'h-screen z-20 top-0 left-0 w-[270px] -ml-[100%] bg-primary transition-all duration-300 ease-in-out dark:bg-darkmode-800',
          '[&[data-simplebar]]:fixed [&_.simplebar-scrollbar]:before:bg-black/50',
          activeMobileMenu.value && 'ml-0',
        ])
      )
    }, [
      _createElementVNode("a", {
        onClick: _cache[3] || (_cache[3] = (e) => e.preventDefault()),
        class: _normalizeClass([
          'fixed top-0 right-0 mt-4 mr-4 transition-opacity duration-200 ease-in-out',
          !activeMobileMenu.value && 'invisible opacity-0',
          activeMobileMenu.value && 'visible opacity-100',
        ])
      }, [
        _createVNode(_unref(Lucide), {
          icon: "XCircle",
          class: "w-8 h-8 text-white transform -rotate-90",
          onClick: _cache[2] || (_cache[2] = 
            () => {
              setActiveMobileMenu(!activeMobileMenu.value);
            }
          )
        })
      ], 2),
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formattedMenu.value, (menu, index) => {
          return (_openBlock(), _createBlock(MobileMenuComponent, {
            key: index,
            menuIndex: index,
            menu: menu,
            isRoot: true,
            setActiveMobileMenu: setActiveMobileMenu
          }, null, 8, ["menuIndex", "menu"]))
        }), 128))
      ])
    ], 2)
  ], 2))
}
}

})